import script from "./EmployeeInductionFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeInductionFormView.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeInductionFormView.vue?vue&type=style&index=0&id=44f7cd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f7cd7c"]])

export default __exports__